import { Button } from "@chakra-ui/button";
import { Heading, Stack, VStack } from "@chakra-ui/layout";
import { chakra } from "@chakra-ui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import useAuth from "hooks/useAuth";
import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Link } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";
import { apiErrorHandler } from "utils/errors";
import * as yup from "yup";
import { loginWithEmailAndPassword } from "..";
import { Layout } from "../components/Layout";
import { LoginField } from "../components/LoginField";

type LoginFormValues = {
  email: string;
  password: string;
};

const schema = yup.object({
  email: yup.string().email().required(),
  password: yup.string().required(),
});

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { loginSuccess } = useAuth();

  const { register, setError, formState, handleSubmit } =
    useForm<LoginFormValues>({
      resolver: schema && yupResolver(schema),
    });
  const { mutate, isLoading } = useMutation({
    mutationFn: loginWithEmailAndPassword,
    onSuccess: (data) => {
      loginSuccess(data);
      navigate("/");
    },
    onError: (e: any) => apiErrorHandler(e, setError),
  });

  return (
    <Layout title="Se connecter">
      <VStack
        spacing={4}
        justify="center"
        w={["full", null, null, "container.lg"]}
        p={["20px"]}
      >
        <Heading
          fontWeight="normal"
          fontSize="20px"
          color="brand.primary"
          mt={8}
          mb={16}
        >
          Connexion à l'application de Teddy
        </Heading>

        <chakra.form
          id="register"
          onSubmit={handleSubmit(async (values: any) => {
            mutate(values);
          })}
          width={["full", "350px"]}
          maxWidth={"350px"}
        >
          <>
            <Stack spacing="24px" direction={"column"} mb={2} px={["20px"]}>
              <LoginField
                error={formState.errors["email"]}
                registration={register("email")}
                placeholder={"Email"}
              />

              <LoginField
                error={formState.errors["password"]}
                registration={register("password")}
                placeholder={"Mot de passe"}
                type="password"
              />
              <Link
                as={ReactRouterLink}
                to="/auth/lostpassword"
                fontWeight="normal"
                fontSize="12px"
                color="brand.primary"
                textAlign="center"
              >
                Mot de passe oublié ?
              </Link>
            </Stack>
            <Button
              bg="brand.primary"
              type="submit"
              h="48px"
              isLoading={isLoading}
              mt={10}
            >
              Connexion
            </Button>
          </>
        </chakra.form>
      </VStack>
    </Layout>
  );
};
